<template>
  <UiCard>
    <img
      :src="img"
      alt=""
      :class="$style.img"
    >
    <UiCardBody>
      <h3 :class="$style.name">
        {{ name }}
      </h3>
      <p :class="$style.disc">
        {{ disc }}
      </p>
       <h4 :class="$style.map"><a v-bind:href="map">Quest Locate >></a></h4>
      <div :class="$style.price">
        N$ {{ price }}
      </div>
    </UiCardBody>
  </UiCard>
</template>

<script>
import {
  UiCard,
  UiCardBody,
} from './ui/UiCard.vue';

export default {
  name: `ProductCard`,
  components: {
    UiCard,
    UiCardBody,
  },
  props: {
    img: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    disc: {
      required: true,
      type: String,
    },
    map: {
      required: true,
      type: String,
    },
    price: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" module>
.img {
  width: 100%;
}

.name {
  font-size: 1.5em;
}
.disc {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}
.map {
  margin-top: 10px;
}

.price {
  margin-top: 0.5em;
  font-size: 1.25em;
}
</style>
